import React, { useRef, useState } from "react";
import { Button, Select, Form, DatePicker, Modal, Row, Col } from "antd";
import {
  CloseOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import Axios from "../../../api/Axios";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
const { Option } = Select;
const { RangePicker } = DatePicker;
const UpdateSub = ({
  billings,
  handleCancel,
  visible,
  application,
  start_date,
  end_date,
  billing_cycle,
  renderApplication,
  contract_id,
  app_id,
  upgradeSuccessfull,
  upgradeFailed,
}) => {
  const formRef = useRef();
  const { id } = useParams();
  // const [isUserExists, setIsUserExists] = useState(false);
  const [loading, setLoading] = useState(false);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const onFinish = async (values, event) => {
    setLoading(true);
    const { dateRange, products, ...otherValues } = values;
    const filteredValues = Object.fromEntries(
      Object.entries(otherValues).filter(
        ([_, value]) => value !== undefined && value !== null
      )
    );

    const startDate = dayjs(dateRange[0]);
    const endDate = dayjs(dateRange[1]);
    let payload = {
      ...filteredValues,
      billing_cycle: billing_cycle,
      start_date: startDate.format("YYYY-MM-DD"),
      end_date: endDate.format("YYYY-MM-DD"),
      organization: parseInt(id, 10),
      application: renderApplication(),
      subscription_type: "",
      subscription_category: "",
      contract_id: Number(contract_id),
    };
    if (application === "GRADEBldr") {
      payload.is_upgrade = true;
    } else if (application === "JA/MP") {
      payload.is_downgrade = true;
    }
    //console.log(payload, "finalPayload");

    try {
      await Axios.put(`/orgsubscription/${app_id}/`, payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      handleReset();
      setLoading(false);
      if (application === "GRADEBldr") {
        upgradeSuccessfull("upgraded");
      } else if (application === "JA/MP") {
        upgradeSuccessfull("downgraded");
      }
    } catch (err) {
      //console.log(err);
      handleReset();
      setLoading(false);
      if (application === "GRADEBldr") {
        upgradeFailed("upgraded");
      } else if (application === "JA/MP") {
        upgradeFailed("downgraded");
      }
    }
  };

  const handleReset = () => {
    //console.log("Cancelling")
    handleCancel();
    formRef.current.resetFields();
  };
  const [form] = Form.useForm();
  const handleFormChange = async (changedValues, allValues) => {
    if ("contract_id" in changedValues && allValues.contract_id.length > 2) {
      await Axios.get(
        `/contractidcheck/${id}/?search=${allValues.contract_id}`
      );
      //console.log(response);
      // setIsUserExists(response.data.exists);
    }
  };

  return (
    <Modal
      title={
        <p className="modal-heading">
          {application === "GRADEBldr" ? "UPGRADE MODULE" : "DOWNGRADE MODULE"}
        </p>
      }
      centered
      // open={modalOpen}
      // onOk={() => setModalOpen(false)}
      // onCancel={() => setModalOpen(false)}
      width={940}
      open={visible}
      onCancel={() => {
        handleReset();
      }}
      footer={[]}
    >
      <div style={{ marginBottom: "0.5rem" }}>
        <div style={{ marginTop: "1rem" }}>
          <Form
            name="complex-form"
            form={form}
            onFinish={onFinish}
            onValuesChange={handleFormChange}
            layout="vertical"
            ref={formRef}
            labelCol={{
              span: 25,
            }}
            initialValues={{
              dateRange: [
                start_date ? dayjs(start_date, "YYYY-MM-DD") : null,
                end_date ? dayjs(end_date, "YYYY-MM-DD") : null,
              ],
            }}
            wrapperCol={{
              span: 80,
            }}
            style={{
              Width: "100%",
            }}
            requiredMark={false}
          >
            <div className="group1" style={{ padding: "0rem" }}>
              <div className="antd-test-modal" style={{ marginTop: "2rem" }}>
                <Row gutter={20} style={{ marginLeft: "2rem" }}>
                  <Col xs={24} sm={12} md={5} lg={5} xl={5}>
                    <Form.Item
                      label={<p className="my-form-lables">Billing Cycle</p>}
                    >
                      <Form.Item
                        name="billing_cycle"
                        initialValue={billing_cycle}
                      >
                        <Select
                          placeholder="Billing"
                          name="billing_cycle"
                          className="my-form-input-antd-test"
                          // onChange={handleBillingCycleChange}
                        >
                          {billings?.billing_cycle?.map((app) => (
                            <Option key={app} value={app}>
                              {app}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={10} lg={8} xl={8}>
                    <Form.Item
                      label={
                        <p className="my-form-lables">Start and End Date</p>
                      }
                    >
                      <Form.Item
                        name="dateRange"
                        rules={[
                          {
                            required: true,
                            message: "date is required",
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              const endDate = getFieldValue("dateRange")?.[1];
                              //console.log(endDate, value);
                              if (!endDate) {
                                return Promise.reject("End date is required");
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <RangePicker
                          placeholder={["Start Date", "End Date"]}
                          name="dateRange"
                          className="my-form-input-antd-test"
                          format="MMM-DD-YYYY"
                        />
                      </Form.Item>
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                height: "2rem",
                marginTop: "0.1rem",
                marginBottom: "1rem",
              }}
            >
              <Form.Item style={{ marginRight: "1rem" }}>
                <Button key="back" onClick={() => handleReset()}>
                  <CloseOutlined />
                  Cancel
                </Button>
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    background: "#f58029",
                    fontWeight: "600",
                    display: "flex",
                  }}
                  className="save-update-btn"
                  disabled={loading}
                >
                  {application === "GRADEBldr" ? (
                    <>
                      {loading ? <LoadingOutlined /> : <CaretUpOutlined />}
                      {loading ? "Upgrading to JA/MP" : "Upgrade to JA/MP"}
                    </>
                  ) : (
                    <>
                      {loading ? <LoadingOutlined /> : <CaretDownOutlined />}
                      {loading
                        ? "Downgrading to GRADEBldr"
                        : "Downgrade to GRADEBldr"}
                    </>
                  )}
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>
    </Modal>
  );
};

export default UpdateSub;
